import React from 'react'

const ChartIcon = props => (
  <svg width={16} height={16} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 16h4V0H6v16zm-6 0h4V8H0v8zm12 0V5h4v11h-4z"
      fill="#004360"
    />
  </svg>
)

export default ChartIcon
